import React, { useState, useEffect } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { normalizedName } from './CompanyName'
import CompanyApi from '../../api/CompanyApi'
import { CompanyEntity } from 'types/CompanyEntity'

function CompanySelect({ onSelectCompany }: { onSelectCompany: (v: Pick<CompanyEntity, 'id'> | null) => void }) {
    const [companies, setCompanies] = useState<(CompanyEntity & { name: string })[] | null>(null)
    const [selectedCompany, setSelectedCompany] = useState<CompanyEntity | null>(null)
    const companyApi = new CompanyApi()

    useEffect(() => {
        const fetchData = async () => {
            const fetchedCompanies = await companyApi.findAll()
            const mappedCompanies = fetchedCompanies
                .map((c, index, arr) => {
                    let name = c.name ?? 'Namn saknas'
                    const prevOccurencies = arr.slice(0, index).filter((_c) => _c.name === c.name)

                    if (prevOccurencies.length) {
                        // if duplicate names, update the name to include an index
                        name += ` (${prevOccurencies.length + 1})`
                    }

                    return {
                        ...c,
                        name,
                    }
                })
                .sort((a, b) => a.name.localeCompare(b.name))
            setCompanies(mappedCompanies)
        }
        if (!companies) {
            void fetchData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!companies) return null
    return (
        <Autocomplete
            value={selectedCompany}
            onChange={(event, newValue) => {
                setSelectedCompany(newValue)
                if (onSelectCompany) onSelectCompany(newValue)
            }}
            options={companies}
            getOptionLabel={(company) => normalizedName(company.name) as string}
            renderInput={(params) => <TextField {...params} label='Välj bolag' />}
        />
    )
}

export { CompanySelect }
